import { ticks } from 'd3-array';

import {
  ceilWithPrecision,
  floorWithPrecision,
} from '../chart-precision/chart-precision';

const Y_AXIS_PERCENTAGE_PADDING = 0.1;
const APPROXIMATE_TICKS_COUNT = 5;

const increaseValue = (value: number, roundDown = false) => {
  const increaseBy = Math.abs(value) * Y_AXIS_PERCENTAGE_PADDING;

  return value + (roundDown ? -1 : 1) * increaseBy;
};

export const getChartTicks = (yMin: number, yMax: number) => {
  const yMaxRounded = ceilWithPrecision(increaseValue(yMax));
  const yMinRounded = floorWithPrecision(increaseValue(yMin, true));

  const chartTicks = ticks(yMinRounded, yMaxRounded, APPROXIMATE_TICKS_COUNT);

  return {
    chartTicks,
    yMinRounded,
    yMaxRounded,
  };
};
